import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { API_ENDPOINTS } from "../constants/api-endpoints.constant";
import { ApiService } from "./api.service";
@Injectable({
  providedIn: "root"
})
export class AdvertisementService {
  public contentType = new BehaviorSubject(<any>"");

  constructor(private _apiService: ApiService) { }

  createAdvertisement(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}`;
    return this._apiService.post(url, data);
  }
  getPresignedUrl(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.ADVERTISEMENT_PRESIGNED_URL}`;
    return this._apiService.put(url, params);
  }
  addToCart(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key == 'material_advertisement_ids' && data['material_advertisement_ids']) {
        Object.entries(data['material_advertisement_ids']).forEach(([k, v]) => {
          formData.append(`advertisement[${key}][]`, v.toString() as string);
        });
      } else if (key == 'geographical_area' && data['geographical_area']) {
        Object.entries(data['geographical_area']).forEach(([k, v]) => {
          formData.append(`advertisement[${key}][]`, v.toString() as string);
        });
      }
      else if (key == 'slots' && data['slots']) {
        Object.entries(data['slots']).forEach(([k, v]) => {
          formData.append(`advertisement[${key}][${v['id']}]`, v['file'] as string);
        });
      }
      else {
        formData.set(`advertisement[${key}]`, value as string);
      }
    })
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}`;
    return this._apiService.post(url, formData);
  }
  searchUser(param) {
    const formData = new FormData();
    formData.set('params[search]', param);
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.ADVERTISEMENT_SEARCH}?search=` + param;
    return this._apiService.get(url);
  }
  getAdvertisementContent(param) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.MATERIAL_PROMOTION}?user_id=${param}`;
    return this._apiService.get(url);
  }
  allowAdvertisement(param) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.CHECK_PERMISSION}?id=${param}`;
    return this._apiService.get(url);
  }
  getPublicAdvertisements(param) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.ACCEPTED_PUBLIC_ADVERTISEMENT}?user_id=${param}`;
    return this._apiService.get(url);
  }
  getReservedSpaceSlots(param: any) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.RESERVED_SLOTS}`;
    return this._apiService.post(url, param);
  }
  loadMaterial(userId: any) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.MATERIAL}?user_id=${userId}`;
    return this._apiService.get(url);
  }
  loadMaterialAds(materialId) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.MATERIAL_PROMOTION}?material_id=${materialId}`;
    return this._apiService.get(url);
  }

  checkValidAd(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key == 'material_advertisement_ids' && data['material_advertisement_ids']) {
        Object.entries(data['material_advertisement_ids']).forEach(([k, v]) => {
          formData.append(`advertisement[${key}][]`, v.toString() as string);
        });
      } else if (key == 'geographical_area' && data['geographical_area']) {
        Object.entries(data['geographical_area']).forEach(([k, v]) => {
          formData.append(`advertisement[${key}][]`, v.toString() as string);
        });
      } else if (key == 'slots' && data['slots']) {
        Object.entries(data['slots']).forEach(([k, v]) => {
          formData.append(`advertisement[${key}][${v['id']}]`, v['file'] as string);
        });
      }
      else {
        if(key != 'file_name'){
          formData.set(`advertisement[${key}]`, value as string);  
        }
      }

    })
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.ADVERTISEMENT}${API_ENDPOINTS.API.CHECK_VALID}`;
    return this._apiService.post(url, formData);
  }

  getAdSlots(content_id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.SLOTS}` + '?content_id=' + content_id;
    return this._apiService.get(url);
  }

  updateAdSlots(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.SLOTS}${API_ENDPOINTS.API.UPDATESLOTS}`;
    return this._apiService.patch(url, data);
  }

}
